import { createBrowserHistory } from 'history';

function getConfirmation(message: string, callback: (isAllowed: boolean) => void) {
	callback(window.confirm(message)); // eslint-disable-line no-alert
}

/** The admin router's history, so code outside components (thunks) can navigate like a router link. */
export const adminHistory = createBrowserHistory({ getUserConfirmation: getConfirmation });
